import i18n from "@/i18n/i18n";

export default {
  get steps() {
    return [
      {
        element: "[data-testid='feedback-items-all-button']",
        popover: {
          title: i18n.t("onboarding.essayPage.step1.title"),
          description: i18n.t("onboarding.essayPage.step1.description"),
          side: "top",
          align: "center",
        },
      },
    ];
  },
};
